import { Col, Row } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import award1 from '../assets/images/birthday/award1.svg';
import award2 from '../assets/images/birthday/award2.svg';
import award3 from '../assets/images/birthday/award3.svg';
import balloon from '../assets/images/birthday/balloon.svg';
import desktopBanner from '../assets/images/birthday/desktopBanner2.png';
import mobileBanner from '../assets/images/birthday/mBanner2.png';
import { HEADERMENU_PATH } from '../routes/RoutesURL';
import HSButton from './common/Button';

const AnniversaryRebate: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div>
            <div className="mt-[80px] relative">
                <img src={desktopBanner} alt="banner" className="w-full hidden md:flex" />
                <img src={mobileBanner} alt="banner" className="w-full flex md:hidden" />
                <div className="absolute tc_text bottom-20 w-full sm:bottom-40 md:bottom-4 lg:bottom-8 xl:bottom-10">
                    <div className="flex justify-center items-center text-gray-300 cursor-pointer hover:text-gray-300 hover:underline underline text-xs WorkSans">
                        <a
                            href={`${HEADERMENU_PATH.rebate}#t&c`}
                            className="text-gray-300 cursor-pointer hover:text-gray-300 hover:underline underline text-xs WorkSans"
                        >
                            Terms & Conditions apply*
                        </a>
                    </div>
                </div>
            </div>
            <div className="px-4 md:px-10 bg-white py-8 pt-16">
                <Row>
                    <p className="text-base text-center md:text-left font-black mb-10" style={{ color: '#27AE60' }}>
                        We are thrilled to announce that on 18th January 2023, we will be celebrating #5yearsofHelicap!
                    </p>
                    <Col xs={24} md={16}>
                        <p className="mb-6 text-[15px] text-justify">
                            To celebrate this momentous occasion, we will be having a rebate promotion, allowing our
                            clients to receive up to US$10,000 for new investments on the Helicap Fund.*
                        </p>
                        <p className="mb-6 text-[15px] text-justify">
                            Additionally, we are delighted to share that our company has recently been recognised with
                            several awards:
                        </p>
                        <div className="flex items-center justify-center md:justify-start">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                <img src={award3} alt="award1" />
                                <img src={award1} alt="award1" />
                                <img src={award2} alt="award1" />
                            </div>
                        </div>
                        <p className="my-6 text-[15px] text-justify">
                            Using our proprietary tech-enabled risk management model, we would also like to share that
                            our diversified private debt investment portfolio has generated consistent returns,
                            delivering 57 consecutive months^ of around 10% annualised net returns, as of end December
                            2022.
                        </p>
                        <p className="mb-6 text-[15px] text-justify">
                            We would like to take this opportunity to thank our valued partners and clients for their
                            ongoing support and trust in Helicap Group.
                        </p>
                        <p className="text-xs">^From April 2018 to December 2022.</p>
                    </Col>
                    <Col xs={24} md={8} className="flex justify-center items-center">
                        <img src={balloon} alt="balloon" />
                    </Col>
                </Row>

                <div id="t&c" className="pb-4 md:pt-0 flex justify-center items-center relative -top-9">
                    <HSButton
                        title="VIEW FUND DETAILS"
                        style={{ backgroundColor: '#27AE60', borderRadius: '9999px', border: 'none' }}
                        className="rounded-full"
                        onClick={() => navigate(`/deal/${process.env.REACT_APP_FUND_DEAL_UUID}`)}
                    />
                </div>

                <div className="anniversary_collapse">
                    <p className="mr-4 main_title text-justify">
                        * Helicap Investor Rebate Program – Terms and Conditions
                    </p>

                    <div className="anniversary_panel ml-3">
                        <p className="title">Eligibility</p>
                        <p className="desc">
                            The Helicap Investor Rebate Program is conducted by Helicap Securities Pte. Ltd. (“Helicap”)
                            and is open to all Approved Investors on the Platform of Helicap Securities Pte. Ltd. at the
                            link{' '}
                            <a
                                target="_blank"
                                rel="noreferrer"
                                className="text-blue-500 underline"
                                href="https://investor.helicap.com/login"
                            >
                                http://investor.helicap.com/login
                            </a>{' '}
                            (“Helicap Securities Platform”). Helicap reserves all rights to reject any rebate requests
                            if the user is not an Approved Investor.
                        </p>
                        <p className="desc">
                            The “Qualifying Period” for the Helicap Investor Rebate Program (“Program”) is valid from
                            1st January 2023 to 30th June 2023, capped at the Maximum Investment Amount received.
                            Eligible Approved Investors have until 30th June 2023 23:59 SGT. Past investments made
                            before 1st January 2023 and investments made after the Maximum Investment Amount received
                            are not eligible for this Program.
                        </p>
                        <p className="desc">
                            The “Maximum Investment Amount” is US$10 million of investment received by the Helicap
                            Income Opportunities Fund between 1st January 2023 to 30th June 2023.
                        </p>
                        <p className="desc">
                            A user is an “Approved Investor” when he/she successfully completes the following the steps
                            listed below in order to have a successful “Rebate Request”:
                        </p>
                        <ul className="list-decimal pl-4 text-base">
                            <li className="my-3">
                                Successful completion of the following account opening procedure on the Helicap
                                Securities Platform:
                                <ul className="list-disc pl-4 text-base">
                                    <li>Verification of accredited investor or institutional investor status;</li>
                                    <li>Passed Helicap’s Know-Your-Customer (KYC) review;</li>
                                    <li>
                                        Signed Non-Disclosure Agreement and all necessary Agreements on the Platform;
                                        and
                                    </li>
                                </ul>
                            </li>
                            <li className="my-3">
                                Successfully invests an amount with a minimum of USD$100,000 (“Investment Amount”) into
                                Helicap Income Opportunities Fund, a fund listed on the Helicap Securities Platform,
                                between 1st January 2023 to 30th June 2023, subject to the Maximum Investment Amount.
                            </li>
                        </ul>
                        <p className="desc">
                            The “Rebate Amount” shall be 1% of the Investment Amount, with the maximum Rebate Amount
                            capped at US$10,000 per Approved Investor. The Rebate Amount is payable within 30 days after
                            the Investment Amount has been fully invested on the Helicap Securities Platform, and shall
                            be credited into the same bank account where the Investment Amount was remitted from.
                        </p>
                        <p className="title">General</p>
                        <p className="desc">
                            By participating in this Program, each Approved Investor is deemed to have accepted and
                            agrees to be bound by these Terms and Conditions contained herein and other instructions,
                            terms and conditions that Helicap may issue from time to time.
                        </p>
                        <p className="desc">Helicap has the sole and absolute discretion right to:</p>
                        <ul className="list-decimal pl-4 text-base">
                            <li className="my-3">
                                Amend the Terms and Conditions of the Program at any time, without prior notice. In the
                                event of any inconsistency or discrepancy between the Terms and Conditions contained
                                herein and the contents of any materials or website relating to this Program, these
                                Terms and Conditions shall prevail;
                            </li>
                            <li className="my-3">
                                Make the decision on all matters relating to this Program and it is final and binding on
                                all Approved Investors, including determining whether a rebate is eligible under these
                                terms; and
                            </li>
                            <li className="my-3">
                                To disqualify any Approved Investors, and in the event that the Rebate Amount has been
                                issued, Helicap reserves the right to withhold or claw back the Rebate Amount in full or
                                part without compensation in its sole discretion, if the Approved Investor does not
                                comply with the Terms and Conditions contained herein, and/or is found to be not
                                Eligible to participate/to receive the Rebate Amount, or reasonably suspected of
                                participating in any form of fraudulent practices (including but not limited to false
                                identities, doctoring images, wilful spamming or manipulation of any Helicap’s
                                processes, or website).
                            </li>
                            <li>Any and all payable Rebate Amount is of the sole and final discretion of Helicap.</li>
                        </ul>
                        <p className="desc">
                            Helicap reserves the right to deal with any unclaimed Rebate Amount, in any manner it deems
                            fit, in its sole discretion.
                        </p>
                        <p className="desc">
                            A person who is not a party to any agreement governed by these Terms and Conditions shall
                            have no right under the Contracts (Right of Third Parties) Act (Cap 53B) to enforce any of
                            these Terms and Conditions.
                        </p>
                        <p className="desc underline">Contact Us Information</p>
                        <p className="desc">
                            If the Eligible Customer fails to receive an email from Helicap after 30 days from the end
                            of the promotion period, kindly reach out to us at our{' '}
                            <a
                                className="text-blue-500 underline"
                                href={`${process.env.REACT_APP_LANDING_WEB_URL}/contact`}
                            >
                                {' '}
                                Contact Us
                            </a>{' '}
                            page .
                        </p>
                        <p className="desc underline">Helicap Policy and Terms of Use</p>
                        <p className="desc">
                            By participating in this Program, Approved Investors agree to the Terms and Conditions of
                            this Program, you will also agree to the{' '}
                            <a
                                className="underline text-blue-500"
                                href={`${process.env.REACT_APP_LANDING_WEB_URL}/terms-of-service`}
                            >
                                Terms of Service
                            </a>{' '}
                            and{' '}
                            <a
                                className="underline text-blue-500"
                                href={`${process.env.REACT_APP_LANDING_WEB_URL}/privacy-policy`}
                            >
                                Privacy Policy
                            </a>{' '}
                            of{' '}
                            <a className="underline text-blue-500" href={`${process.env.REACT_APP_LANDING_WEB_URL}`}>
                                Helicap.com
                            </a>
                            .
                        </p>
                        <p className="desc">
                            This Program shall be construed in accordance with and governed in all respects by Singapore
                            law. The Parties hereby submit to the exclusive jurisdiction of the courts of Singapore.
                        </p>
                    </div>
                    {/* </Panel> */}
                </div>
            </div>
        </div>
    );
};

export default AnniversaryRebate;
